<div class="ops-input-preview-container" [class.disabled]="isDisabled">
  <label *ngIf="label" class="ops-input-label">
    {{ label }}
  </label>

  <div *ngIf="isPreview && !textOnly" class="ops-input preview">
    <span>{{ value }}</span>
  </div>

  <div *ngIf="textOnly" class="ops-input preview text-only">
    <span>{{ value }}</span>
  </div>

  <input
    *ngIf="!isPreview && !textOnly"
    tabindex="-1"
    [value]="value"
    [disabled]="isDisabled"
    readonly
    class="ops-input"
  />

  <span *ngIf="noteText && !isPreview" class="ops-input-note">{{
    noteText
  }}</span>
</div>
